import React from 'react';
import PropTypes from 'prop-types';


const InfoCard = ({ title, icon, children, actions }) => (
  <div className="info-card-container">
    <div className="info-card-header d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center gap-2">
        {icon && <i className={`fa ${icon} pr-2`} />}
        <span>{title}</span>
      </div>
      <div className="info-card-actions">
        {actions}
      </div>
    </div>
    <div className="card-body">
      {children}
    </div>
  </div>
);

InfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  children: PropTypes.node,
  actions: PropTypes.node
};

export default InfoCard;
